export const trim = (str: string) => str.replace(/\s+/g, '')

export const toCamelCase = (string: string) => {
  const match = string.match(/(\w+)/g)

  return match?.map((p, i) => (i ? p.substr(0, 1).toUpperCase() + p.substr(1) : p)).join('')
}

export const firstLetterToLowerCase = (string: string) => string.charAt(0).toLowerCase() + string.slice(1)
